import React, { memo } from 'react';
import { Handle, Position } from 'react-flow-renderer';

const DecisionNode = ({ data, isConnectable }) => {
  return (
    <div className="node node-decision">
      <Handle type="target" position={Position.Top} isConnectable={isConnectable} />
      <div>
        <h4>{data.label}</h4>
        {data.conditions && data.conditions.length > 0 && (
          <div>
            <p>Conditions: {data.conditions.length}</p>
            <ul style={{ fontSize: '0.8rem', paddingLeft: '15px' }}>
              {data.conditions.slice(0, 2).map((condition, index) => (
                <li key={index}>{condition.condition || 'undefined'}</li>
              ))}
              {data.conditions.length > 2 && <li>...</li>}
            </ul>
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} id="default" isConnectable={isConnectable} />
      
      {/* Add multiple handles for conditions - in a real implementation, these would be dynamic */}
      <Handle 
        type="source" 
        position={Position.Right} 
        id="condition1" 
        style={{ top: '30%' }} 
        isConnectable={isConnectable} 
      />
      <Handle 
        type="source" 
        position={Position.Right} 
        id="condition2" 
        style={{ top: '70%' }} 
        isConnectable={isConnectable} 
      />
    </div>
  );
};

export default memo(DecisionNode); 